import { User } from 'Douleutaras/types';
import { LOCAL_STORAGE_KEY } from 'Douleutaras/constants/system';
import { AuthObjectFormat } from 'Douleutaras/interfaces/auth';

export const updateStoredUser = (u: User): void => {
  let stored: AuthObjectFormat = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.USER_CREDENTIALS));
  if (stored) {
    stored.v.user = u;
  } else {
    stored = { v: { user: u } };
  }
  localStorage.setItem(LOCAL_STORAGE_KEY.USER_CREDENTIALS, JSON.stringify(stored));
};

export const getStoredUser = (): User => {
  // Use the user's object stored in the session.
  const stored: AuthObjectFormat = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.USER_CREDENTIALS));

  return stored ? stored.v.user : undefined;
};

// Get NOW unix timestamp in seconds
// getNow() -> 1720784839
export const getNow = (): number => parseInt((Date.now() / 1000).toString(), 10);
